import React, { useState } from 'react'
import { Card, Col, Dropdown, Row } from 'react-bootstrap'
import './PackagesPage.scss'
import PackageList from './PackageList/PackageList'
import { Package } from '@geartrack/shared-lib/dist/packages.model'
import AddPackageModal from '../../components/AddPackageModal/AddPackageModal'
import PackageModel from '@geartrack/shared-lib/dist/PackageModel'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'
import GoogleAd from '../../components/GoogleAd'
import PackageInformationBody from './PackageTimelines/PackageInformationBody'
import usePackagesRepository from '../../hooks/usePackagesRepository'
import { usePackages } from '../../components/PackagesProvider'

const PackagesPage = () => {
  const packages = usePackages()
  console.log('Rendering PackagesPage', packages)

  return (
    <div className="packages-page">
      <Row>
        <Col md={5} lg={4}>
          <PackageList packages={packages} />

          <div className={classNames('mt-3')}>
            <GoogleAd client="ca-pub-3952596231252607" slot="3325581507" />
          </div>
        </Col>
        <Col md={7} lg={8} className="mt-3 mt-md-0">
          <PackageTimelines packages={packages} />
        </Col>
      </Row>

      <AddPackageModal />
    </div>
  )
}

const PackageTimelines = React.memo(({ packages }: { packages: PackageModel[] }) => {
  const { t } = useTranslation('packages')

  if (packages.length === 0) {
    return <div>{t('timeline.no packages')}</div>
  }

  return (
    <>
      {packages.map((pkg, i) => (
        <div className={classNames(i < packages.length - 1 ? 'mb-3' : '')} key={pkg.computedKey}>
          <Row>
            <Col>
              <PackageInformationCard pkg={pkg} />
            </Col>
          </Row>
          {shouldPlaceAd(i, pkg.collapsed) && (
            <div className="mt-3">
              <GoogleAd client="ca-pub-3952596231252607" slot="6040278711" />
            </div>
          )}
        </div>
      ))}
    </>
  )
})

const PackageInformationCard = React.memo(({ pkg }: { pkg: PackageModel }) => {
  const pkgsRepo = usePackagesRepository()
  const [isLoading, setLoading] = useState(true)

  return (
    <Card className="tracking-object" id={pkg.computedKey}>
      <Card.Header
        className="pointer bg-secondary text-light d-flex"
        onClick={() => pkgsRepo.toggleCollapsePackage(pkg)}
      >
        <div className="flex-grow-1 text-truncate">
          {!pkg.isDescriptionEmpty() ? (
            <>
              <h3 className="card-title d-inline">
                <i className="fas fa-box-alt me-2 fa-lg" />
                {pkg.description}
              </h3>
              <span className="ms-2">{pkg.trackingId}</span>
            </>
          ) : (
            <>
              <h3 className="card-title d-inline">
                <i className="fas fa-box-alt me-2 fa-lg" />
                {pkg.trackingId}
              </h3>
              <span className="ms-2">{pkg.trackingId}</span>
            </>
          )}

          {pkg.extraData ? <span className="ms-2 text-muted">{pkg.getExtraDataString()}</span> : null}
        </div>
        <div>{!pkg.collapsed && isLoading ? <i className="fas fa-circle-notch fa-spin" /> : ''}</div>
      </Card.Header>
      <Card.Body className="p-0">
        {!pkg.collapsed && (
          <div className="px-2 py-2">
            <PackageInformationBody pkg={pkg} setLoading={setLoading} />
          </div>
        )}
      </Card.Body>
    </Card>
  )
})

export const PackageOptionsCard = React.memo(({ pkg }: { pkg: Package }) => {
  return (
    <Dropdown onClick={e => e.stopPropagation()}>
      <Dropdown.Toggle variant="dark" id={'dropdown-package-card-' + pkg.computedKey}>
        <i className="fas fa-cog" />
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item>
          <i className="fas fa-edit mr-2" />
          Some options that we might need
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  )
})

function shouldPlaceAd(i, collapsed) {
  // we don't want to show an Ad if we're not showing the order details
  if (collapsed) return false

  // not a uniform distribution, hand-picked to not show too many ads
  return [1, 3, 6, 9, 12].includes(i)
}

export default PackagesPage
